module.exports = __webpack_public_path__ + "img/caiwufenxi.195d59a7.svg";